module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ju3RUL/tc-custom/9781459229921.jpg?1741132405493",
      "alt": "This image is the cover for the book Gladiator's Honor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gladiator's Honor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Sold into slavery!")]), _c('br'), _c('br'), _vm._v("A hardened survivor of more than a dozen gladiatorial combats, Valens’s raw masculinity fuels many women’s sexual fantasies. He is outside polite society, and Roman noblewoman Julia Antonia knows she should have nothing to do with a man who is little more than a slave."), _c('br'), _c('br'), _vm._v("But with a wisp of scandal clinging to her "), _c('i', [_vm._v("stola")]), _vm._v(", Julia is drawn inexorably toward the forbidden danger he represents. For Valens, Julia is a tantalizing reminder of the life he’d been torn from. To claim her, he must fight one final timeand win!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michelle Styles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michelle Styles writes warm, witty and intimate historical romance in a range of periods including Viking  and early Victorian. Born and raised near San Francisco, California,  she  currently lives near Hadrian's Wall in the UK with her husband, menagerie of pets and occasionally one of her three university-aged children. An avid reader, she became hooked on historical romance after discovering  Georgette Heyer, Anya Seton and Victoria Holt.   ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0